// removed by extract-text-webpack-plugin
module.exports = {"banner":"_2KYmE2psy__kGgtb3lq0Xm","logodDiv":"_2pvJ_wl-TzLNrzQJPlulJ_","logoImg":"pPyBOSThRQwNORZOhYXMF","divFlexEnd":"_3u4MK0JfDSFGWFPG6NZVFL","textBanner":"fQBjbzmmnYu2ZmDathJ7L","textTop":"_3CuzL9tvbWdqChcom_kPhX","textBottom":"_2nZ7V4YRa_bFaBDsPU3DMx","finalFlex":"_3JV37KjAhlUnUNHgJRCUZ1","openButtonDiv":"_2WaHyfQ78BurDSfc-wl6tw","openButton":"_1nnpQ3qY3Jxaj0hNipNbAq","closeBanner":"_1FgE-ZhLInpUfOR5F-jhfi","closeIcon":"_28MaR0NSlOgAd7GjsEsmPo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/HeaderBanner.scss
// module id = 1118
// module chunks = 0